export const GETRESERVOIRAREALIST = 'GETRESERVOIRAREALIST' // 获取库区列表
export const SAVERESERVOIRAREA = 'SAVERESERVOIRAREA' // 保存
export const DELRESERVOIRAREA = 'DELRESERVOIRAREA' // 删除
export const GETRESERVOIRAREADETAILS = 'GETRESERVOIRAREADETAILS' // 获取详情



// WEBPACK FOOTER //
// ./src/store/reservoirAreaManage/types.js